import { Injectable } from "@angular/core";
import { UrlService } from "@uirouter/core";

const GETEXCEPTIONAL_SUBDOMAINS = [
  "getexceptional",
  "exceptional-test1",
  "exceptional-test2",
];

@Injectable()
export class FeatureFlagService {
  constructor(private urlService: UrlService) {}

  public getexceptional() {
    const subdomain = this.urlService.config.host().split(".")[0];
    return GETEXCEPTIONAL_SUBDOMAINS.indexOf(subdomain) > -1;
  }
}
